// import Button from "@components/atoms/button";
// import Divider from "@components/atoms/divider";
// import TextField from "@components/atoms/input";
import Footer from "@components/molecules/footer";
// import Layout from "@components/molecules/layout";
import { LoaderSnackbarWrapperActions } from "@components/organisms/LoaderSnackbarWrapper/LoaderSnackbarWrapper.slice";
// import { actionCodeSettings } from "@config/firebase/auth_email_link_actioncode_settings";
import { auth } from "@config/firebase/firbaseConfig";
// import theme from "@config/theme";
// import Box from "@mui/material/Box";
// import Checkbox from "@mui/material/Checkbox";
// import Link from "@mui/material/Link";
// import Typography from "@mui/material/Typography";
// import { useFormik } from "formik";
import { useEffect, useState } from "react";
// import {
//   useSendSignInLinkToEmail,
//   useSignInWithApple,
//   useSignInWithGoogle,
// } from "react-firebase-hooks/auth";
import { ConnectedProps, connect } from "react-redux";
// import * as Yup from "yup";

import {
  Container,
  Content,
  LogoWrapper,
  Stack,
  SubTitle,
  Title,
  TitleWrapper,
  Wrapper,
} from "./signIn.styled";

import { ReactComponent as Logo } from "@assets/images/logo/logos.svg";
import { StyledFirebaseAuth } from "@components/organisms/firebase-ui";

import * as firebaseui from 'firebaseui';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

type ReduxProps = ConnectedProps<typeof connector>;

const SignIn = ({ setAlert, setLoader, setCookieConsent }: ReduxProps) => {
  // const [hasAgreed, setHasAgreed] = useState<boolean>();
  // const [signInWithGoogle, , googleLoading, googleError] =
  //   useSignInWithGoogle(auth);

  // const [signInWithApple] = useSignInWithApple(auth);

  // const [sendSignInLinkToEmail, sending, error] =
  //   useSendSignInLinkToEmail(auth);

  // const signIpWithMagicLink = async () => {
  //   const success = await sendSignInLinkToEmail(
  //     formik.values.email,
  //     actionCodeSettings
  //   );
  //   if (success) {
  //     localStorage.setItem("emailForSignIn", formik.values.email);
  //     setAlert({
  //       alert: {
  //         isVisible: !sending,
  //         message: `Check your email! We've sent you a login link to ${formik.values.email}`,
  //         type: "success",
  //       },
  //     });
  //   }
  // };

  // const formik = useFormik({
  //   initialValues: {
  //     email: "",
  //   },
  //   validationSchema: Yup.object({
  //     email: Yup.string().email("Invalid email address").required("Required"),
  //   }),
  //   onSubmit: () => {},
  // });

  // useEffect(() => {
  //   setLoader({ loader: sending, isBlankLoader: false });

  //   if (error) {
  //     setAlert({
  //       alert: {
  //         isVisible: !!error,
  //         message: error?.message,
  //         type: "error",
  //       },
  //     });
  //   }
  // }, [sending, error, setAlert, setLoader]);

  // useEffect(() => {
  //   setLoader({ loader: googleLoading, isBlankLoader: true });

  //   if (googleError) {
  //     setAlert({
  //       alert: {
  //         isVisible: !!googleError,
  //         message: googleError?.message,
  //         type: "error",
  //       },
  //     });
  //   }
  // }, [googleError, googleLoading, setAlert, setLoader]);

  useEffect(() => {
    setCookieConsent({ cookieConsent: false });
  }, []);

  const firebaseUiConfig = {
    // Popup signin flow rather than redirect flow.
    signInFlow: 'popup',
    // Redirect to / after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
    signInSuccessUrl: '/',
    signInOptions: [
      {
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        emailLinkSignIn: "",
        forceSameDevice: false,
        requireDisplayName: false,
        buttonColor: '#129479',
        fullLabel: 'Continue with Email',
        // Use email link authentication and do not require password.
        // Note this setting affects new users only.
        // For pre-existing users, they will still be prompted to provide their
        // passwords on sign-in.
        // signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
      },
      {
        provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        scopes: [
          // 'https://www.googleapis.com/auth/fitness.activity.read',
          'https://www.googleapis.com/auth/userinfo.email',
          'https://www.googleapis.com/auth/userinfo.profile',
          // "openid"
        ],
        customParameters: {
          // Forces account selection even when one account
          // is available.
          prompt: 'select_account'
        },
        fullLabel: 'Continue with Google',
      },
      // {
      //   provider: firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      //   fullLabel: 'Continue with Twitter',
      //   // buttonColor: '#14171A',
      //   // iconUrl: XLogo
      // },
      // {
      //   provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      //   scopes: [
      //     'public_profile',
      //     'email',
      //     'user_likes',
      //     'user_friends'
      //   ],
      //   customParameters: {
      //     // Forces password re-entry.
      //     auth_type: 'reauthenticate'
      //   }
      // },
      // firebase.auth.GithubAuthProvider.PROVIDER_ID,
    ],
    credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
    tosUrl: 'https://rkbt.ai/terms-and-conditions',
    privacyPolicyUrl: function() {
      window.open(
        "https://rkbt.ai/privacy-policy",
        "_blank"
      )
    }
  };

  return (
    <Container>
      <Content>
        <LogoWrapper>
          <Logo />
          <TitleWrapper>
            <Title>rkbt</Title>
            <SubTitle>Football. Casually Professional.</SubTitle>
          </TitleWrapper>
        </LogoWrapper>
        <Wrapper>
          <Stack>
            <StyledFirebaseAuth uiConfig={firebaseUiConfig} firebaseAuth={auth}/>
          </Stack>
          {/*<Stack>
            <TextField
              name={"email"}
              placeholder="Email address"
              value={formik.values.email}
              touched={formik.touched.email}
              errorMessage={formik.errors.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Button
              textColor={theme.palette.grey[100]}
              isDisabled={!(formik.isValid && formik.dirty)}
              color="secondary"
              text={"Continue with email"}
              type={"button"}
              onClick={() => {
                if (!hasAgreed) {
                  setHasAgreed(false);
                } else {
                  signIpWithMagicLink();
                }
              }}
            />
          </Stack>*/}
          {/*<Divider text="or" orientation="horizontal" />*/}
          {/*<Stack>
            <Button
              textColor={theme.palette.grey[900]}
              color="neutral"
              text={"Continue with Google"}
              type={"button"}
              onClick={() => {
                if (!hasAgreed) {
                  setHasAgreed(false);
                } else {
                  signInWithGoogle();
                }
              }}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              <Checkbox
                onChange={(e) => {
                  setHasAgreed(e.target.checked);
                }}
              />
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"start"}
              >
                <Typography fontSize={"15px"}>
                  I have read and agree to the{" "}
                  <Link
                    sx={{
                      wordWrap: "break-word",
                      cursor: "pointer",
                      fontSize: "15px",
                    }}
                    onClick={() =>
                      window.open(
                        "https://rkbt-public.s3.eu-west-2.amazonaws.com/privacy-policy.html",
                        "_blank"
                      )
                    }
                  >
                    Privacy policy
                  </Link>{" "}
                  and{" "}
                  <Link
                    sx={{
                      wordWrap: "break-word",
                      cursor: "pointer",
                      fontSize: "15px",
                    }}
                    onClick={() =>
                      window.open(
                        "https://rkbt-public.s3.eu-west-2.amazonaws.com/terms-and-conditions.html",
                        "_blank"
                      )
                    }
                  >
                    Terms & Conditions
                  </Link>
                  .
                </Typography>
                {hasAgreed === false && (
                  <Typography color={"red"}>
                    This is required to continue
                  </Typography>
                )}
              </Box>
            </Box>
          </Stack>*/}
        </Wrapper>
      </Content>
      <Footer />
    </Container>
  );
};
const mapDispatchToProps = {
  setAlert: LoaderSnackbarWrapperActions.setGlobalAppearances,
  setLoader: LoaderSnackbarWrapperActions.setGlobalAppearances,
  setCookieConsent: LoaderSnackbarWrapperActions.setGlobalAppearances,
};

const connector = connect(undefined, mapDispatchToProps);
const SignInRedux = connector(SignIn);

export { SignInRedux as SignIn };
